/* src/routes/blog/3d-printer-build.svelte generated by Svelte v3.32.3 */
import {
	SvelteComponent,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	mount_component,
	noop,
	safe_not_equal,
	space,
	text,
	transition_in,
	transition_out
} from "../../../_snowpack/pkg/svelte/internal.js";

import Gallery from "../../../_components/Gallery.svelte.js";
import PostTop from "../../../_components/Post-Top.svelte.js";
import PostContents from "../../../_components/Post-Contents.svelte.js";
import PostSection from "../../../_components/Post-Section.svelte.js";
import Callout from "../../../_components/Callout.svelte.js";
import LinkExternal from "../../../_components/Link-External.svelte.js";

function create_default_slot_9(ctx) {
	let t;

	return {
		c() {
			t = text("Richard Horne");
		},
		l(nodes) {
			t = claim_text(nodes, "Richard Horne");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (24:4) <LinkExternal       href="http://richrap.blogspot.co.uk/2013/07/3dr-reprap-delta-printer-part-1-release.html">
function create_default_slot_8(ctx) {
	let t;

	return {
		c() {
			t = text("3DR RepRap Delta Printer");
		},
		l(nodes) {
			t = claim_text(nodes, "3DR RepRap Delta Printer");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (32:4) <LinkExternal href="https://github.com/jcrocholl">
function create_default_slot_7(ctx) {
	let t;

	return {
		c() {
			t = text("jcrocholl");
		},
		l(nodes) {
			t = claim_text(nodes, "jcrocholl");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (34:4) <LinkExternal href="https://github.com/jcrocholl/rostock">
function create_default_slot_6(ctx) {
	let t;

	return {
		c() {
			t = text("Rostock");
		},
		l(nodes) {
			t = claim_text(nodes, "Rostock");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (40:6) <LinkExternal         href="https://github.com/RichRap/MARLIN_FIRMWARE_for_3DR_V2">
function create_default_slot_5(ctx) {
	let t;

	return {
		c() {
			t = text("RichRap 3DR Firmware");
		},
		l(nodes) {
			t = claim_text(nodes, "RichRap 3DR Firmware");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (45:6) <LinkExternal         href="http://richrap.blogspot.co.uk/2013/07/3dr-reprap-delta-printer-part-1-release.html">
function create_default_slot_4(ctx) {
	let t;

	return {
		c() {
			t = text("Assembly Tutorial Series");
		},
		l(nodes) {
			t = claim_text(nodes, "Assembly Tutorial Series");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (38:4) <Callout title="Links">
function create_default_slot_3(ctx) {
	let linkexternal0;
	let t0;
	let br;
	let t1;
	let linkexternal1;
	let current;

	linkexternal0 = new LinkExternal({
			props: {
				href: "https://github.com/RichRap/MARLIN_FIRMWARE_for_3DR_V2",
				$$slots: { default: [create_default_slot_5] },
				$$scope: { ctx }
			}
		});

	linkexternal1 = new LinkExternal({
			props: {
				href: "http://richrap.blogspot.co.uk/2013/07/3dr-reprap-delta-printer-part-1-release.html",
				$$slots: { default: [create_default_slot_4] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(linkexternal0.$$.fragment);
			t0 = space();
			br = element("br");
			t1 = space();
			create_component(linkexternal1.$$.fragment);
		},
		l(nodes) {
			claim_component(linkexternal0.$$.fragment, nodes);
			t0 = claim_space(nodes);
			br = claim_element(nodes, "BR", {});
			t1 = claim_space(nodes);
			claim_component(linkexternal1.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(linkexternal0, target, anchor);
			insert(target, t0, anchor);
			insert(target, br, anchor);
			insert(target, t1, anchor);
			mount_component(linkexternal1, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const linkexternal0_changes = {};

			if (dirty & /*$$scope*/ 4) {
				linkexternal0_changes.$$scope = { dirty, ctx };
			}

			linkexternal0.$set(linkexternal0_changes);
			const linkexternal1_changes = {};

			if (dirty & /*$$scope*/ 4) {
				linkexternal1_changes.$$scope = { dirty, ctx };
			}

			linkexternal1.$set(linkexternal1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(linkexternal0.$$.fragment, local);
			transition_in(linkexternal1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(linkexternal0.$$.fragment, local);
			transition_out(linkexternal1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(linkexternal0, detaching);
			if (detaching) detach(t0);
			if (detaching) detach(br);
			if (detaching) detach(t1);
			destroy_component(linkexternal1, detaching);
		}
	};
}

// (17:2) <PostSection title="Background">
function create_default_slot_2(ctx) {
	let t0;
	let linkexternal0;
	let t1;
	let linkexternal1;
	let t2;
	let br;
	let t3;
	let linkexternal2;
	let t4;
	let linkexternal3;
	let t5;
	let callout;
	let current;

	linkexternal0 = new LinkExternal({
			props: {
				href: "http://richrap.blogspot.co.uk/",
				$$slots: { default: [create_default_slot_9] },
				$$scope: { ctx }
			}
		});

	linkexternal1 = new LinkExternal({
			props: {
				href: "http://richrap.blogspot.co.uk/2013/07/3dr-reprap-delta-printer-part-1-release.html",
				$$slots: { default: [create_default_slot_8] },
				$$scope: { ctx }
			}
		});

	linkexternal2 = new LinkExternal({
			props: {
				href: "https://github.com/jcrocholl",
				$$slots: { default: [create_default_slot_7] },
				$$scope: { ctx }
			}
		});

	linkexternal3 = new LinkExternal({
			props: {
				href: "https://github.com/jcrocholl/rostock",
				$$slots: { default: [create_default_slot_6] },
				$$scope: { ctx }
			}
		});

	callout = new Callout({
			props: {
				title: "Links",
				$$slots: { default: [create_default_slot_3] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			t0 = text("I was inspired to create this printer after seeing a very informative video\n    by\n    ");
			create_component(linkexternal0.$$.fragment);
			t1 = text("\n    on his\n    ");
			create_component(linkexternal1.$$.fragment);
			t2 = text("\n    (his tutorial series on the printer is very helpful and covers all aspects\n    of the build process).\n    ");
			br = element("br");
			t3 = text("\n    The printer is a Delta printer (a design made famous by\n    ");
			create_component(linkexternal2.$$.fragment);
			t4 = text("\n    and his\n    ");
			create_component(linkexternal3.$$.fragment);
			t5 = text("\n    printer.\n    ");
			create_component(callout.$$.fragment);
		},
		l(nodes) {
			t0 = claim_text(nodes, "I was inspired to create this printer after seeing a very informative video\n    by\n    ");
			claim_component(linkexternal0.$$.fragment, nodes);
			t1 = claim_text(nodes, "\n    on his\n    ");
			claim_component(linkexternal1.$$.fragment, nodes);
			t2 = claim_text(nodes, "\n    (his tutorial series on the printer is very helpful and covers all aspects\n    of the build process).\n    ");
			br = claim_element(nodes, "BR", {});
			t3 = claim_text(nodes, "\n    The printer is a Delta printer (a design made famous by\n    ");
			claim_component(linkexternal2.$$.fragment, nodes);
			t4 = claim_text(nodes, "\n    and his\n    ");
			claim_component(linkexternal3.$$.fragment, nodes);
			t5 = claim_text(nodes, "\n    printer.\n    ");
			claim_component(callout.$$.fragment, nodes);
		},
		m(target, anchor) {
			insert(target, t0, anchor);
			mount_component(linkexternal0, target, anchor);
			insert(target, t1, anchor);
			mount_component(linkexternal1, target, anchor);
			insert(target, t2, anchor);
			insert(target, br, anchor);
			insert(target, t3, anchor);
			mount_component(linkexternal2, target, anchor);
			insert(target, t4, anchor);
			mount_component(linkexternal3, target, anchor);
			insert(target, t5, anchor);
			mount_component(callout, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const linkexternal0_changes = {};

			if (dirty & /*$$scope*/ 4) {
				linkexternal0_changes.$$scope = { dirty, ctx };
			}

			linkexternal0.$set(linkexternal0_changes);
			const linkexternal1_changes = {};

			if (dirty & /*$$scope*/ 4) {
				linkexternal1_changes.$$scope = { dirty, ctx };
			}

			linkexternal1.$set(linkexternal1_changes);
			const linkexternal2_changes = {};

			if (dirty & /*$$scope*/ 4) {
				linkexternal2_changes.$$scope = { dirty, ctx };
			}

			linkexternal2.$set(linkexternal2_changes);
			const linkexternal3_changes = {};

			if (dirty & /*$$scope*/ 4) {
				linkexternal3_changes.$$scope = { dirty, ctx };
			}

			linkexternal3.$set(linkexternal3_changes);
			const callout_changes = {};

			if (dirty & /*$$scope*/ 4) {
				callout_changes.$$scope = { dirty, ctx };
			}

			callout.$set(callout_changes);
		},
		i(local) {
			if (current) return;
			transition_in(linkexternal0.$$.fragment, local);
			transition_in(linkexternal1.$$.fragment, local);
			transition_in(linkexternal2.$$.fragment, local);
			transition_in(linkexternal3.$$.fragment, local);
			transition_in(callout.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(linkexternal0.$$.fragment, local);
			transition_out(linkexternal1.$$.fragment, local);
			transition_out(linkexternal2.$$.fragment, local);
			transition_out(linkexternal3.$$.fragment, local);
			transition_out(callout.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(t0);
			destroy_component(linkexternal0, detaching);
			if (detaching) detach(t1);
			destroy_component(linkexternal1, detaching);
			if (detaching) detach(t2);
			if (detaching) detach(br);
			if (detaching) detach(t3);
			destroy_component(linkexternal2, detaching);
			if (detaching) detach(t4);
			destroy_component(linkexternal3, detaching);
			if (detaching) detach(t5);
			destroy_component(callout, detaching);
		}
	};
}

// (54:2) <PostSection title="Photos">
function create_default_slot_1(ctx) {
	let gallery;
	let current;

	gallery = new Gallery({
			props: {
				images: [
					"/content/blog/images/3d-printer-build/Electronics1.jpg",
					"/content/blog/images/3d-printer-build/Electronics2.jpg",
					"/content/blog/images/3d-printer-build/Electronics3.jpg",
					"/content/blog/images/3d-printer-build/base.jpg",
					"/content/blog/images/3d-printer-build/base_with_alu_extrusions.jpg",
					"/content/blog/images/3d-printer-build/Base_alu_closeup.jpg",
					"/content/blog/images/3d-printer-build/base_top_carriage.jpg",
					"/content/blog/images/3d-printer-build/base_top_carriage2.jpg",
					"/content/blog/images/3d-printer-build/carriage.jpg",
					"/content/blog/images/3d-printer-build/carriage_with_wire.jpg",
					"/content/blog/images/3d-printer-build/axis_motors.jpg",
					"/content/blog/images/3d-printer-build/axis_carriage2.jpg",
					"/content/blog/images/3d-printer-build/axis_carriage_3.jpg",
					"/content/blog/images/3d-printer-build/hotend.jpg",
					"/content/blog/images/3d-printer-build/readytoprint.jpg"
				]
			}
		});

	return {
		c() {
			create_component(gallery.$$.fragment);
		},
		l(nodes) {
			claim_component(gallery.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(gallery, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(gallery.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(gallery.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(gallery, detaching);
		}
	};
}

// (16:0) <PostContents>
function create_default_slot(ctx) {
	let postsection0;
	let t;
	let postsection1;
	let current;

	postsection0 = new PostSection({
			props: {
				title: "Background",
				$$slots: { default: [create_default_slot_2] },
				$$scope: { ctx }
			}
		});

	postsection1 = new PostSection({
			props: {
				title: "Photos",
				$$slots: { default: [create_default_slot_1] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(postsection0.$$.fragment);
			t = space();
			create_component(postsection1.$$.fragment);
		},
		l(nodes) {
			claim_component(postsection0.$$.fragment, nodes);
			t = claim_space(nodes);
			claim_component(postsection1.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(postsection0, target, anchor);
			insert(target, t, anchor);
			mount_component(postsection1, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const postsection0_changes = {};

			if (dirty & /*$$scope*/ 4) {
				postsection0_changes.$$scope = { dirty, ctx };
			}

			postsection0.$set(postsection0_changes);
			const postsection1_changes = {};

			if (dirty & /*$$scope*/ 4) {
				postsection1_changes.$$scope = { dirty, ctx };
			}

			postsection1.$set(postsection1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(postsection0.$$.fragment, local);
			transition_in(postsection1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(postsection0.$$.fragment, local);
			transition_out(postsection1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(postsection0, detaching);
			if (detaching) detach(t);
			destroy_component(postsection1, detaching);
		}
	};
}

function create_fragment(ctx) {
	let posttop;
	let t;
	let postcontents;
	let current;

	posttop = new PostTop({
			props: {
				title,
				tags: /*tags*/ ctx[0],
				projects: /*projects*/ ctx[1]
			}
		});

	postcontents = new PostContents({
			props: {
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(posttop.$$.fragment);
			t = space();
			create_component(postcontents.$$.fragment);
		},
		l(nodes) {
			claim_component(posttop.$$.fragment, nodes);
			t = claim_space(nodes);
			claim_component(postcontents.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(posttop, target, anchor);
			insert(target, t, anchor);
			mount_component(postcontents, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			const postcontents_changes = {};

			if (dirty & /*$$scope*/ 4) {
				postcontents_changes.$$scope = { dirty, ctx };
			}

			postcontents.$set(postcontents_changes);
		},
		i(local) {
			if (current) return;
			transition_in(posttop.$$.fragment, local);
			transition_in(postcontents.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(posttop.$$.fragment, local);
			transition_out(postcontents.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(posttop, detaching);
			if (detaching) detach(t);
			destroy_component(postcontents, detaching);
		}
	};
}

const title = "3D Printer 1 - Build";
const date = "2014-01-23";

function instance($$self) {
	const tags = ["hardware", "build"];
	const projects = ["3D-Printer"];
	return [tags, projects];
}

class _3d_printer_build extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default _3d_printer_build;
//# sourceMappingURL=3d-printer-build.svelte.js.map
